import { MediaRelationshipTypes } from "~/types";

/**
 * Custom filter data for professional articles (Fachartikel)
 * Excludes: Umfang, Inklusiver Religionsunterricht, Medienkompetenz, Anwendungsbereich
 */
export const sortProfessionalArticleFilterData = (filterData: any) => [
  {
    id: "mediaKindIds",
    name: "Medientyp",
    options: filterData[MediaRelationshipTypes.MEDIA_KIND],
  },
  {
    id: "thematicFocusIds",
    name: "Themenschwerpunkte",
    options: filterData[MediaRelationshipTypes.THEMATICFOCUS],
  },
  {
    id: "subjectIds",
    name: "Gegenstandsbereiche",
    options: filterData[MediaRelationshipTypes.SUBJECT],
  },
  {
    id: "specialIds",
    name: "Einsatzbereich",
    options: filterData[MediaRelationshipTypes.SPECIAL],
  },
  {
    id: "restrictionPresenceIds",
    name: "Zugriff",
    options: filterData[MediaRelationshipTypes.RESTRICTION],
  },
  {
    id: "licenseIds",
    name: "Lizenz",
    options: filterData[MediaRelationshipTypes.LICENCE],
  },
];
